/* Native Shopify product form enhancement. With JS off, POST /cart/add still works. */
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-fs-product]').forEach(product => {
      if (product.dataset.initialized) return;
      product.dataset.initialized = 'true';
      const form = product.querySelector('form'), select = form?.querySelector('[name="id"]');
      if (!form || !select) return;
      const status = product.querySelector('[data-product-status]'), add = product.querySelector('[data-add-button]');
      const showMedia = id => {
        if (!id || !product.querySelector(`[data-media-panel="${CSS.escape(id)}"]`)) return;
        product.querySelectorAll('[data-media-panel]').forEach(panel => {
          panel.hidden = panel.dataset.mediaPanel !== id;
          if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
        });
        product.querySelectorAll('[data-media-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === id)));
      };
      product.querySelectorAll('[data-media-target]').forEach(button => button.addEventListener('click', () => showMedia(button.dataset.mediaTarget)));
      const buttons = product.querySelector('[data-variant-buttons]');
      // Keep the native selector for multi-option / large catalogs. Compact sizes enhance small runs.
      if (select.options.length > 1 && select.options.length <= 8) {
        Array.from(select.options).forEach(option => {
          const button = document.createElement('button');
          button.type = 'button'; button.textContent = option.textContent; button.disabled = option.disabled;
          button.dataset.variant = option.value; button.setAttribute('aria-pressed', String(option.selected));
          button.addEventListener('click', () => { select.value = option.value; select.dispatchEvent(new Event('change')); });
          buttons.append(button);
        });
        buttons.hidden = false;
      }
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        product.querySelector('[data-product-price]').textContent = option.dataset.price;
        const compare = product.querySelector('[data-product-compare]');
        compare.textContent = option.dataset.compare; compare.hidden = option.dataset.sale !== 'true';
        add.disabled = option.dataset.available !== 'true';
        add.innerHTML = add.disabled ? 'SOLD OUT' : 'ADD TO BAG <span aria-hidden="true">↗</span>';
        buttons.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.variant === option.value)));
        status.textContent = ''; showMedia(option.dataset.media);
        const quantity = form.querySelector('[name="quantity"]');
        quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        const min = Number(quantity.min), step = Number(quantity.step);
        let next = Math.max(min, min + Math.round((Number(quantity.value) - min) / step) * step);
        if (quantity.max) next = Math.min(next, Number(quantity.max));
        quantity.value = String(next);
        const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
      });
      const dialog = product.querySelector('dialog');
      if (dialog) {
        const open = product.querySelector('[data-size-open]');
        const close = () => { dialog.close(); open.focus(); };
        open.addEventListener('click', () => dialog.showModal());
        product.querySelector('[data-size-close]').addEventListener('click', close);
        dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); } });
      }
      form.addEventListener('submit', async event => {
        event.preventDefault(); if (!form.reportValidity() || add.disabled) return;
        add.disabled = true; add.setAttribute('aria-busy', 'true'); status.textContent = 'Adding to your bag…';
        const data = new FormData(form), cart = document.querySelector('cart-drawer');
        if (cart) { data.append('sections', cart.getSectionsToRender().map(section => section.id).join(',')); data.append('sections_url', location.pathname); cart.setActiveElement(add); }
        try {
          const response = await fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
          if (cart && result.sections) { cart.classList.remove('is-empty'); cart.renderContents(result); status.textContent = 'Added to your bag.'; }
          else { location.assign(window.routes.cart_url); }
        } catch (error) { status.textContent = error.message || 'Connection failed. Please try again.'; }
        finally { add.disabled = select.selectedOptions[0]?.dataset.available !== 'true'; add.removeAttribute('aria-busy'); }
      });
    });
    root.querySelectorAll('.fs-mobile-menu a').forEach(link => link.addEventListener('click', () => link.closest('details').open = false));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
